import selectedOptionStyles from "components/select/partial/selcted-styles.css.js";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const menuStyle = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default theme => ({
  container: {
    width: "100%",
  },
  ...selectedOptionStyles,
});
